/**
 * Categories matching CXB EU. Main + legacy for backward compatibility.
 */
import { mainCategories } from './mainCategories';
import { legacyCategories, CONDITIONS, CONDITION_KEYS, conditionKey } from './legacyCategories';
import { categoriesV2, categoryMigrationMap, migrateSubcategory, getSubcategoriesV2, getSubcategoryById } from './categoriesV2';
export { getTopCategories, getCachedTopCategories } from './getTopCategories';

export const CATEGORIES = [...mainCategories, ...legacyCategories];
export const CATEGORIES_V2 = categoriesV2;

export { CONDITIONS, CONDITION_KEYS, conditionKey, categoryMigrationMap, migrateSubcategory, getSubcategoriesV2, getSubcategoryById };

export const getCategoriesSorted = () =>
  [...CATEGORIES].sort((a, b) => a.order - b.order);

export const getCategoriesForHome = () =>
  getCategoriesSorted().filter((c) => c.order <= 15);

export const getAllCategoryNames = () => CATEGORIES.map((c) => c.name);

export const getSubcategories = (categoryName) => {
  const cat = CATEGORIES.find(
    (c) => c.name.toLowerCase() === (categoryName || '').toLowerCase()
  );
  return cat?.subcategories ?? [];
};
